import z, { array, object, string, any } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { withIsEnabled } from '../utils/with-is-enabled';

const AwardRestrictionsEnabledSchema = object({
  awards: array(object({ id: string(), name: string() })).min(1, IS_REQUIRED),
});

const AwardRestrictionsDisabledSchema = object({
  awards: any(),
}).passthrough();

export const AwardRestrictionsSchema = withIsEnabled(
  AwardRestrictionsEnabledSchema,
  AwardRestrictionsDisabledSchema,
);

export type AwardRestrictionsFormValues = z.infer<typeof AwardRestrictionsSchema>;
